import { render, staticRenderFns } from "./Zh.vue?vue&type=template&id=f8ebf39c&scoped=true"
import script from "./Zh.vue?vue&type=script&lang=js"
export * from "./Zh.vue?vue&type=script&lang=js"
import style0 from "./Zh.vue?vue&type=style&index=0&id=f8ebf39c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ebf39c",
  null
  
)

export default component.exports